import { render } from "./testbuildertable.vue?vue&type=template&id=0b7b0947"
import script from "./testbuildertable.vue?vue&type=script&lang=js"
export * from "./testbuildertable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__